export default __webpack_public_path__ + "static/media/farmers_market.12840e10.svg";